import { LitElement, css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

import './tfp-page'
import '../components/tfp-button'

import { when } from 'lit/directives/when.js'
import { Router } from '@vaadin/router'
import { localized, msg } from '@lit/localize'
import { authService } from '../services/auth-service'
import { AuthStateController } from '../components/auth-state-controller'


@customElement('tfp-unauthorized-page')
@localized()
export class TFPUnauthorizedPage extends LitElement {
  // Make sure that component is updated when auth state changes
  // @ts-expect-error to avoid warning about unused, this is here for its side effects.
  private authListener = new AuthStateController(this);


  render() {
    return html`
    <tfp-page>
      ${when(authService.state.isAuth,
          () => {
            Router.go('/');
            return html`<div></div>`;
          },
          () => html`

            <div style="display: grid; grid-auto-rows: min-content; gap: 10px; grid-template-columns: 1fr; padding: 20px;">
              <div>
                <img style="width: 50%; apect-ratio: 1;" src="/trainfitpro.svg"> </img>
              </div>

               <div style="color: var(--tfp-md-color-on-background); text-align: center; font-weight: 700;">
                 <i>${msg(html`TRAIN SMARTER &bull; GET FIT &bull; GO PRO`)}</i>
               </div>

              <p>
                ${msg('Welcome here!')}
              </p>
              <p>
                ${msg('Unfortunately you are not authorized to use this application. Please, feel free to check back at a later date.')}
              </p>

              <tfp-button .text=${msg('Back to login page')} @tfp-action=${() => Router.go('/')}> </tfp-button>
            </div>
          `
        )
      }
    </tfp-page>
    `
  }

  static styles = css`
    :host {
      margin: 0;
      text-align: center;
      display: grid;
      grid-template-rows: minmax(0, 1fr);
      height: 100%;
    }


  `
}

declare global {
  interface HTMLElementTagNameMap {
    'tfp-unauthorized-page': TFPUnauthorizedPage
  }
}
